import React, { Suspense } from 'react';
import { isMobile } from 'react-device-detect';

const WebTheme = React.lazy(() => import('./WebTheme'));
const MobileTheme = React.lazy(() => import('./MobileTheme'));

const AppTheme = ({ children }) => {
  return (
    <>
      <Suspense fallback={<div>Loading...</div>}>
        <section>
          <WebTheme />
        </section>
      </Suspense>
      {children}
    </>
  );
};

export default AppTheme;
